/**
 * A simple feature detection utility that runs a callback and updates the value to the result
 * of the callback or to false if the callback errors.
 *
 * @param callback
 * @returns a boolean value if the callback has been run (true if await callback() is true, false if
 * it is false or errors) or undefined if the callback has not been run yet
 */
export default function useSupported(callback) {
    let supported = $state(undefined);
    callback()
        .then((res) => {
        supported = res;
    })
        .catch((_) => {
        supported = false;
    });
    return {
        get isSupported() {
            return supported;
        },
    };
}
